import styled from "styled-components";

const StyledProfile = styled.div`
	.ant-list {
		width: 100%;
		max-width: 800px;
		.ant-list-item {
			background: #fafafa;
			border: none;
			margin-bottom: 16px;
			.ant-list-item-meta {
				align-items: center;

				.ant-list-item-meta-title {
					margin-bottom: 0;
					color: var(--Component-Custom-List-List-1-Text, #000);
					font-family: "DM Sans";
					font-size: 16px;
					font-style: normal;
					font-weight: 600;
					line-height: 24px;
				}
				.ant-list-item-meta-description {
					color: var(--Palettes-Gray-Gray-9, #434343);
					font-family: "DM Sans";
					font-size: 12px;
					font-style: normal;
					font-weight: 500;
					line-height: 24px;
				}
			}
		}
		.action-area {
			max-width: 800px;
			width: 100%;
			button {
				width: 100%;
				min-width: unset;
				max-width: unset;
			}
		}
		.sb-icon {
			width: 32px;
			height: 32px;
			.search {
				transform: rotate(90deg);
			}
			.icon {
				font-size: 24px;
			}
		}
	}

	.sb-profile-container {
		&__body {
			background: ${({ theme }) => theme.colors.athensGray};
			width: 100%;
			min-height: calc(100vh - 400px);
			border-top-left-radius: 35px;
			border-top-right-radius: 35px;
			margin-top: -80px;
			padding: 68px 64px;

			&__title {
				text-align: center;
				margin: 0 auto 32px auto;
			}

			&__logout {
				width: 100%;
				max-width: 800px;
				margin: 48px auto;
				display: block;
			}
		}

		@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
			&__body {
				padding: 16px;

				&__title {
					margin: 70px auto 20px auto;
					text-align: center;
				}
			}
		}
	}
`;

export default StyledProfile;
